


































































import { Vue, Component, Prop } from 'vue-property-decorator';
import KeyArea from '@/domain/drd-2.0/entity/key-area.entity';
import SkillFilter from '@/domain/drd-2.0/entity/skill-filter.entity';
import Skill from '@/domain/drd-2.0/entity/skill.entity';
import SkillService from '@/domain/drd-2.0/service/skill.service';
import DrawerComponent from '@/shared/drawer/drawer.component.vue';
import CreateSkillModal from '../skill/modal/create-skill-modal.component.vue';

@Component({
  components: {
    DrawerComponent,
    CreateSkillModal,
  },
})
export default class SelectSkillDrawer extends Vue {
  @Prop({ type: Boolean, default: () => false })
  value!: boolean;

  @Prop({ type: Object, required: true })
  keyArea!: KeyArea;

  @Prop({ type: Object, required: true })
  skillType!: any;

  skillSearchText: string = '';

  skills: any[] = [];

  skillsPage: number = 1;

  skillsPageSize: number = 20;

  skillsTotal: number = 0;

  loadingSkills: boolean = false;

  openCreateSkillModal: boolean = false;

  newSkillInitialValue: Skill = new Skill({
    type: this.skillType.value,
  });

  fetchSkills(reset = false) {
    if (this.loadingSkills) return;
    this.loadingSkills = true;
    const filter: SkillFilter = new SkillFilter({
      what: this.skillSearchText,
      types: [this.skillType.value],
      hasWhat: !!this.skillSearchText,
      hasTypes: false,
      hasKeyAreaName: false,
      hasAssignments: false,
      hasGroups: false,
    });
    const page = reset ? 1 : this.skillsPage;
    SkillService.search(filter, page, this.skillsPageSize)
      .then((res) => {
        const { data } = res;
        if (reset) {
          this.skills = data.content;
        } else {
          this.skills = [...this.skills, ...data.content];
        }
        this.skillsTotal = data.totalElements;
        this.skillsPage = page;
      })
      .finally(() => {
        this.loadingSkills = false;
      });
  }

  onSkillSearchInput() {
    this.skillsPage = 1;
    this.fetchSkills(true);
  }

  onSkillListScroll(e: Event) {
    const el = e.target as HTMLElement;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 10) {
      if (this.skills.length < this.skillsTotal && !this.loadingSkills) {
        this.skillsPage += 1;
        this.fetchSkills();
      }
    }
  }

  isSkillInKeyArea(skill: Skill) {
    return this.keyArea.skills.some((s: any) => s.skill.id === skill.id && s.active);
  }

  handleSkillSelected(skill: any) {
    const isSelected = this.isSkillInKeyArea(skill);
    if (isSelected) {
      this.removeSkillFromKeyArea(skill);
    } else {
      this.addSkillToKeyArea(skill);
    }
  }

  addSkillToKeyArea(skill: Skill) {
    if (!this.isSkillInKeyArea(skill)) {
      this.$emit('addSkill', skill);
    }
  }

  removeSkillFromKeyArea(skill: Skill) {
    this.$emit('removeSkill', skill);
  }

  handleSkillCreated(skill: Skill) {
    this.$emit('addSkill', skill);
    this.openCreateSkillModal = false;
  }

  handleCreateNewSkill() {
    this.newSkillInitialValue = new Skill({
      type: this.skillType.value,
    });
    this.openCreateSkillModal = true;
  }

  created() {
    this.fetchSkills();
  }
}
